import {
  StatusFiltersLabels,
  StatusFiltersValues,
} from "@/constants/statusFilters";
import { LeadStatus } from "@/v2/enums/LeadStatus";

export const leadStatuses = [
  {
    value: StatusFiltersValues.ANY,
    label: StatusFiltersLabels.ANY,
  },
  {
    value: LeadStatus.NEW,
    label: LeadStatus.NEW,
  },
  {
    value: LeadStatus.CONTACTED,
    label: LeadStatus.CONTACTED,
  },
  {
    value: LeadStatus.CONVERTED,
    label: LeadStatus.CONVERTED,
  },
  {
    value: LeadStatus.NURTURE,
    label: LeadStatus.NURTURE,
  },
  {
    value: LeadStatus.COLD,
    label: LeadStatus.COLD,
  },
];

export function getLeadStatusClass(status: LeadStatus): string {
  if (status === LeadStatus.NEW) {
    return "success";
  }

  if (status === LeadStatus.CONTACTED) {
    return "light-blue";
  }

  if (status === LeadStatus.CONVERTED) {
    return "primary";
  }

  if (status === LeadStatus.NURTURE) {
    return "yellow";
  }

  if (status === LeadStatus.COLD) {
    return "secondary";
  }

  return "";
}
